
























































import { Vue, Component, PropSync } from "vue-property-decorator";
import { CalendarEvent } from "@/types";
import moment from "moment-timezone";
import Event from "@/classes/Event";

@Component({ components: {} })
export default class CalendarCard extends Vue {
  @PropSync("event")
  public readonly calendarEvent!: CalendarEvent;
  @PropSync("height")
  public readonly eventHeight!: number;
  @PropSync("color")
  public readonly eventColor!: string;
  private image: string = "";

  public getLocalTime(time: string) {
    return moment(time).format("LT");
  }

  public async mounted() {
    if (this.calendarEvent.image) {
      this.image = await Event.getEventImage(this.calendarEvent.id);
    }
  }
}
